export default __webpack_public_path__ + "static/media/Anuphan-Medium.dcdb997f.woff2";